module.exports = __webpack_public_path__ + "static/media/0013.bbfb6e7e.jpg";